<template>
  <div class="bg">
    <div class="logo_bg">
      <div class="min_head">
        <div class="head_img_wrap" @click="onPrivacy('personCenter')">
          <img class="head_img" :src="avatarUrl" alt="''" />
          <img v-if="wearImageUrl" class="wear_img" :src="wearImageUrl" alt="" />
        </div>
        <div class="head_name_wrap">
          <div class="username_icon">
            <p class="username" @click="onPrivacy('personCenter')">{{ personName }}</p>
            <p class="user_tips">{{ jobDesc }}</p>
          </div>
          <QrCodeScanner
            :pageType="2"
            @addDecode="handleAdd"
            v-if="
              !isTudoApp &&
              !isSandsTalkFlutterApp &&
              !isSandsTalkMSFlutterApp &&
              !isSandsTalkNativeApp &&
              !isSandsTalkSEAsiaOutfieldApp &&
              !isSandsTalkPhOutfieldApp &&
              !isWisdomRabbitApp
            "
          />
        </div>
      </div>
      <div class="nav_wrapper">
        <div class="nav_item" v-for="(item, index) in navScreen" :key="item.to" @click="goJump(item.to)">
          <p class="item_num">{{ $t(item.num) }}</p>
          <p class="item_name">
            {{ $t(item.name) }}{{ index === 0 ? '(h)' : '' }}
            <Icon name="arrow" class="arrow" />
          </p>
        </div>
        <div v-if="medalCount && medalCount > 0" class="medal_entry" @click="goJump('/myMedalList')">
          <div class="medal_entry_left">
            <img class="medal_entry_icon" src="@/assets/images/my/medal.png" alt="" />
            <div
              class="medal_entry_text"
              v-html="$tVarHtml('您已获得枚勋章', [medalCount], { varClass: 'entry_num' })"
            />
          </div>
          <div class="medal_entry_right">
            <Icon name="arrow" class="arrow" />
          </div>
        </div>
      </div>
    </div>
    <!--    我的   -->
    <div class="business_div">
      <p class="business_title">{{ $t('app_my') }}</p>
      <div class="business_wrapper">
        <div
          class="business_item"
          v-for="(item, index) in myScreen"
          :style="index < 4 ? { paddingBottom: '20px' } : { paddingBottom: '15px' }"
          :key="item.to"
          @click="goJump(item.to)"
        >
          <div class="item_img_box">
            <i :class="['iconfont', item.img]" />
            <span class="badge" v-if="(item.badgeNum || 0) > 0">
              {{ (item.badgeNum || 0) > 99 ? '99+' : item.badgeNum || 0 }}
            </span>
          </div>
          <p class="item_img_name">{{ $t(item.name) }}</p>
        </div>
      </div>
    </div>
    <!--    更多   -->
    <div class="business_div">
      <p class="business_title">{{ $t('app_more') }}</p>
      <div class="business_wrapper">
        <div class="business_item" v-for="item in moreScreen" :key="item.to" @click="goJump(item.to)">
          <div class="item_img_box">
            <i :class="['iconfont', item.img]" />
            <span class="badge" v-if="(item.badgeNum || 0) > 0">
              {{ (item.badgeNum || 0) > 99 ? '99+' : item.badgeNum || 0 }}
            </span>
          </div>
          <p class="item_img_name">{{ $t(item.name) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  ComponentInternalInstance,
  getCurrentInstance,
  reactive,
  toRefs,
  ref,
  onMounted,
  onActivated,
  computed
} from 'vue'
import { useRouter } from 'vue-router'
import { Icon } from 'vant'
import { getUserSimple } from '@/api/requests/RankRequests'
import { getValidateToken } from '@/api/requests/UserRequests'
import { getCornerMarkNumber } from '@/api/requests/TeachManageRequests'
import QrCodeScanner from '@/components/QRCodeScanner.vue'
import { isTudoApp } from '@/utils/tudo'
import { isWisdomRabbitApp } from '@/utils/sandsTalkSmartRabbit'
import { isOutFieldApp } from '@/utils/outfield'
import { isSandsTalkFlutterApp } from '@/utils/sandsTalkFlutter'
import { isSandsTalkMSFlutterApp } from '@/utils/sandsTalkMSFlutter'
import { isSandsTalkNativeApp } from '@/utils/sandsTalkNative'
import { isSandsTalkSEAsiaOutfieldApp } from '@/utils/sandsTalkSEAsiaOutfield'
import { isSandsTalkPhOutfieldApp } from '@/utils/sandsTalkPhOutfiled'
import { toW, toHour } from '@/utils'
import { useAuthStore } from '@/stores/login'
import { getUserLabelInfo } from '@/api/requests/AppRequests'
import { getMyMedalSummary } from '@/api/requests/MyMedal'
const router = useRouter()
const { proxy } = getCurrentInstance() as ComponentInternalInstance

const userInfoData = reactive<{
  username?: string
  jobDesc?: string
  avatarUrl?: string
}>({
  username: '',
  jobDesc: '',
  avatarUrl: require('@/assets/images/wx_share_default.jpg')
})

let isFirstLoad = true
const { avatarUrl, jobDesc } = toRefs(userInfoData)
const authStore = useAuthStore()
const wearImageUrl = computed(() => authStore.wearImageUrl)
const moreScreen = ref()
const personName = ref()
const myMedalSummary = ref<{ awardCount: number } | null>(null)
const medalCount = computed(() => {
  const raw = myMedalSummary.value?.awardCount
  const parsed = typeof raw === 'number' ? raw : Number(raw || 0)
  if (!Number.isNaN(parsed) && parsed > 0) return parsed
  return 0
})
const navScreen = ref([
  {
    name: 'study_time_h5',
    num: '24',
    to: '/studyTime'
  },
  {
    name: 'top_academic_h5',
    num: '9875',
    to: '/topAcademic'
  },
  {
    name: 'total_Integral_h5',
    num: '1.29',
    to: '/integral'
  }
])

// 注意数据顺序，不然影响显示徽标数据
const myScreen = ref([
  {
    name: 'app_my_studies',
    img: 'icon-icon_wode_xuexi',
    to: '/myStudy'
  },
  {
    name: 'app_my_training', // 培新项目
    img: 'icon-icon_wode_wodepeixun',
    to: '/myTraining',
    badgeNum: 0
  },
  {
    name: 'app_my_examination', // 考试与练习
    img: 'icon-icon_wode_kaoshi',
    to: '/examPractise',
    badgeNum: 0
  },
  {
    name: 'app_my_survey', // 调查
    img: 'icon-icon_wode_tiaoyan',
    to: '/mySurvey',
    badgeNum: 0
  },
  {
    name: 'app_offline_teaching',
    img: 'icon-xianxiamianshou',
    to: '/faceTeaching'
  },
  {
    name: 'certificate',
    img: 'icon-zhengshuguanli',
    to: '/myCertificate'
  },
  {
    name: 'pc_community_my_release',
    img: 'icon-icon_wode_wodefabu',
    to: '/myPublish'
  },
  {
    name: 'pc_common_my_love',
    img: 'icon-icon_wode_shoucang',
    to: '/myCollect'
  },
  {
    name: 'file_archive',
    img: 'icon-dangan',
    to: '/myArchive'
  },
  {
    name: '勋章',
    img: 'icon-xunzhang',
    to: '/myMedalList'
  }
])

const moreScreenData1 = [
  {
    name: 'app_feedback',
    img: 'icon-icon_wode_fankui',
    to: '/feedback'
  }
]
const moreScreenData = [
  {
    // 管理员工作台入口
    name: '管理中心',
    img: 'icon-wode-guanli',
    to: '/workBench',
    show: false
  },
  {
    // 团队学习
    name: 'pc_my_team',
    img: 'icon-wode_tuanduixuexi',
    to: '/teamStudyList',
    show: false
  },
  {
    // 教学管理
    name: 'teaching_management', // app_
    img: 'icon-pic_jiaoxueguanli1',
    to: '/teachManage/TeachManageList',
    badgeNum: 0,
    show: false
  },
  {
    name: 'app_my_center',
    img: 'icon-gengduo_gerenzhongxin',
    to: '/personCenter',
    show: true
  },
  {
    name: 'app_feedback',
    img: 'icon-icon_wode_fankui',
    to: '/feedback',
    show: true
  },
  {
    name: 'settings',
    img: 'icon-icon_wode_shezhi',
    to: '/setting',
    show: true
  },
  {
    name: '帮助中心',
    img: 'icon-wode-bangzhu',
    to: '/helpCenter',
    show: true
  }
]

const handleMenu = async () => {
  if (isTudoApp || isOutFieldApp) {
    moreScreen.value = moreScreenData1
    return
  }
  // 保留：获取并修复 userId
  const res = await getValidateToken()
  if (res.code === 1) {
    const authStore = useAuthStore()
    const { setUserId, setWearImageId, setWearImageUrl, setRoleCodes } = authStore
    setUserId(res.data.id)
    setWearImageId(res.data.wearImageId || '')
    setWearImageUrl(res.data.wearImageUrl || '')
    setRoleCodes(res.data.roleCodes || [])
  }

  // 新增：通过 getUserLabelInfo 判断入口显示
  const labelRes = await getUserLabelInfo()
  if (labelRes.code === 1) {
    const { teachingMgtLabel = 0, teamLearningLabel = 0, workbenchLabel = 0 } = labelRes.data || {}
    const map: Record<string, boolean> = {
      '/teamStudyList': teamLearningLabel === 1,
      '/teachManage/TeachManageList': teachingMgtLabel === 1,
      '/workBench': workbenchLabel === 1
    }
    Object.keys(map).forEach((to) => {
      const item = moreScreenData.find((e) => e.to === to)
      if (item) item.show = map[to]
    })
    moreScreen.value = moreScreenData.filter((item) => item.show)
  } else {
    ;['/teamStudyList', '/teachManage/TeachManageList', '/workBench'].forEach((to) => {
      const item = moreScreenData.find((e) => e.to === to)
      if (item) item.show = false
    })
    moreScreen.value = moreScreenData.filter((item) => item.show)
  }
}
const onPrivacy = (value: string) => {
  router.push(`/${value}`)
}

const goJump = (value: string) => {
  router.push(value)
}

const handleAdd = async (result: string) => {
  await router.push({ name: 'TrainingLink', query: { linkUrl: result } })
}

const getSimple = async () => {
  const res = await getUserSimple({})
  if (res.code === 1) {
    const { totalStudyDuringTime, monthRank, totalPoints } = res.data
    const { name, postName, avatarFileUrl } = res.data.user
    personName.value = name
    userInfoData.username = name
    userInfoData.jobDesc = postName
    userInfoData.avatarUrl = avatarFileUrl || require('@/assets/images/wx_share_default.jpg')
    navScreen.value[0].num = toW(toHour(totalStudyDuringTime, 'H')) || '0'
    navScreen.value[1].num = toW(monthRank) || '0'
    navScreen.value[2].num = toW(totalPoints) || '0'
    proxy?.$forceUpdate()
  }
}

const fetchMyMedalSummary = async () => {
  const res = await getMyMedalSummary()
  if (res?.success === true && res?.data) {
    myMedalSummary.value = res.data
    return
  }
  if ((res?.code === 1 || res?.code === 214) && res?.data) {
    myMedalSummary.value = res.data
    return
  }
  myMedalSummary.value = null
}
// 获取徽标
const getBadge = async () => {
  const res = await getCornerMarkNumber()
  if (res.code === 1) {
    const { trainingNumber, examAndPracticeNumber, investigationNumber, teachingNumber, faceNumber } = res.data

    const setBadge = (list: any[], name: string, num: any) => {
      const item = list.find((i) => i.name === name)
      if (item) item.badgeNum = Number(num || 0)
    }
    setBadge(myScreen.value, 'app_my_training', trainingNumber)
    setBadge(myScreen.value, 'app_my_examination', examAndPracticeNumber)
    setBadge(myScreen.value, 'app_my_survey', investigationNumber)
    setBadge(myScreen.value, 'app_offline_teaching', faceNumber)
    setBadge(moreScreenData, 'teaching_management', teachingNumber)
    if (moreScreen.value) {
      setBadge(moreScreen.value, 'teaching_management', teachingNumber)
    }
  }
}

onActivated(() => {
  if (!isFirstLoad) {
    handleMenu()
    getSimple()
    getBadge()
    fetchMyMedalSummary()
  }
})

onMounted(() => {
  console.log('onMounted')
  if (isFirstLoad) {
    getSimple()
    handleMenu()
    getBadge()
    fetchMyMedalSummary()
    // 防止会重复请求
    setTimeout(() => {
      isFirstLoad = false
    }, 1500)
  }
})
</script>

<style lang="less" scoped>
@din_font: 'DIN Condensed, DIN Condensed-Bold, sans-serif', sans-serif;
@ping_fang_font: 'PingFang SC, PingFang SC-Regular, sans-serif';
@import url('@/styles/variables.less');
.iconfont {
  font-size: 28px;
}
.bg {
  min-height: 100vh;
  background-color: #f7f8f9;
  .logo_bg {
    background-image: url('~@/assets/images/my/myBg.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;

    .min_head {
      display: flex;
      align-items: center;
      min-height: 50px;
      padding: 30px 16px 20px;
      .head_img_wrap {
        position: relative;
        width: 44px;
        height: 44px;
        overflow: visible;
        flex-shrink: 0;
      }
      .head_img {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        object-fit: cover;
        display: block;
      }
      .wear_img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        pointer-events: none;
      }
      .head_name_wrap {
        flex: 1;
        height: 100%;
        padding-left: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 0;
        .username_icon {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          min-width: 0;
        }
      }
      .username {
        color: #171921;
        font-size: 20px;
        font-weight: 600;
        max-width: 100%;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
      }
      .user_tips {
        margin-top: 4px;
        font-size: 12px;
        color: #999999;
        word-break: break-all;
        .arrow {
          color: #171921;
        }
      }
    }
  }
}
.business_div {
  background-color: #fff;
  margin: 12px 12px 0;
  border-radius: 12px;
  .business_title {
    font-weight: 500;
    color: #171921;
    font-size: 14px;
    padding: 12px 0 16px 16px;
  }
}

.nav_wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 14px 16px 0;
  border-radius: 12px;
  overflow: hidden;
  background-image: url('~@/assets/images/my/myRank.png');
  background-size: cover;
  background-repeat: no-repeat;
  .nav_item {
    width: calc(100% / 3);
    display: flex;
    flex-direction: column;
    margin-top: 0;
    align-items: center;
    padding: 15px 0 10px;
    box-sizing: border-box;
    .item_num {
      font-size: 20px;
      font-family: @din_font;
      font-weight: 700;
      color: #171921;
    }
    .item_name {
      margin-top: 6px;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #61666d;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 2px;
      .arrow {
        font-size: 12px;
        color: #61666d;
      }
    }
  }

  .medal_entry {
    width: 100%;
    padding: 12px 22px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }

  .medal_entry_left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
  }

  .medal_entry_icon {
    width: 23px;
    height: 32px;
    display: block;
  }

  .medal_entry_text {
    font-size: 14px;
    color: #171921;
    font-weight: 500;
    line-height: 18px;
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .medal_entry_right {
    flex-shrink: 0;
    font-size: 13px;
    color: #61666d;
    line-height: 18px;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    .arrow {
      font-size: 12px;
      color: #61666d;
    }
  }
}

.business_wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 5px;
  .business_item {
    width: calc(100% / 4);
    padding: 0 5px;
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .item_img_box {
    width: 28px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    position: relative;
    .badge {
      min-width: 16px;
      height: 16px;
      padding: 0 2px;
      font-size: 12px;
      background-color: #ef3838;
      border-radius: 16px;
      color: @textWhite;
      .flex_center;
      position: absolute;
      top: 0;
      right: -8px;
    }
  }
  .item_img_name {
    font-size: 12px;
    font-weight: 400;
    color: #171921;
    padding-top: 2px;
    text-align: center;
    // font-family: @ping_fang_font;
  }
  .item_num {
    font-size: 12px;
    font-weight: 400;
    color: #171921;
  }
}
</style>
